import classNames from "classnames";
import React from "react";
import { useEffect, useState } from "react";
import { cleanHtml } from "./cleanHtml";

interface Props {
  /**
   * The HTML to be rendered.
   */
  htmlString: string;

  /**
   * Optional classname to apply to the container element.
   */
  className?: string;

  /**
   * HTML Tag to use for the container element.
   */
  tag?: keyof JSX.IntrinsicElements;

  children?: never[];
}

/**
 * A component to render a string of HTML, probably sourced from one of our content APIs.
 * 
 * @status stable
 */
export const HtmlRenderBlock: React.FC<Props> = (props) => {
  const [cleanedHtml, setCleanedHtml] = useState<string>("");

  useEffect(() => {
    const cleaned = cleanHtml(props.htmlString);
    setCleanedHtml(cleaned);
  }, [props.htmlString]);

  const Element = props.tag ?? "div";

  return (
    <Element
      className={classNames("html-render-block", props.className)}
      dangerouslySetInnerHTML={{ __html: cleanedHtml }}
    />
  );
};

HtmlRenderBlock.defaultProps = {
  tag: "div",
};

HtmlRenderBlock.displayName = "HtmlRenderBlock";
